import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CurrentLegalDocumentsState, currentLegalDocumentsFeatureKey } from '../reducers/legal-documents-current.reducer';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import * as currentLegalDocumentsState from '../reducers/legal-documents-current.reducer';

//#region Employee detail ROOT STATE
export const getMainEmployeeCurrentState = createFeatureSelector<fromEmployeeMainReducer.State, CurrentLegalDocumentsState>(
  fromEmployeeMainReducer.employeeDetailFeatureKey
);
//#endregion

//#region Current Legal Documents SUB STATE
export const getCurrentLegalDocumentsState = createSelector(getMainEmployeeCurrentState, state => state[currentLegalDocumentsFeatureKey]);
//#endregion

//#region Current Legal Documents SELECTORS
export const getCurrentLegalDocumentsRequest = createSelector(
  getCurrentLegalDocumentsState,
  currentLegalDocumentsState.getCurrentLegalDocumentsRequest
);
export const getCurrentLegalDocumentsSuccess = createSelector(
  getCurrentLegalDocumentsState,
  currentLegalDocumentsState.getCurrentLegalDocumentsResponse
);
export const getCurrentLegalDocumentsFailure = createSelector(
  getCurrentLegalDocumentsState,
  currentLegalDocumentsState.getCurrentLegalDocumentsFailure
);
//#endregion
